import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "../../context/I18nContext";
import { getHomeContent } from "./homeContent";
import LeadForm from "./LeadForm";

export default function LeadModal({ open, onClose, ctaSource = "header" }) {
  const { language } = useTranslation();
  const c = getHomeContent(language);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="hf-modal" role="dialog" aria-modal="true" aria-label={c.cta.book}>
      <div className="hf-modal__bg" onClick={onClose} />
      <div className="hf-page hf-modal__panel">
        <button type="button" className="hf-modal__x" aria-label={c.form.close} onClick={onClose}>
          <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
        <LeadForm c={c} language={language} ctaSource={ctaSource} />
      </div>
    </div>,
    document.body,
  );
}
